import { isArray, join } from 'lodash';

// TODO: Make this more generic perhaps and move to utils
export const stringToDisplay = (variable: any) => (isArray(variable) ? join(variable, ', ') : variable);
